import { render, staticRenderFns } from "./testcanvas.vue?vue&type=template&id=a2ed5e7c&scoped=true&"
import script from "./testcanvas.vue?vue&type=script&lang=js&"
export * from "./testcanvas.vue?vue&type=script&lang=js&"
import style0 from "./testcanvas.vue?vue&type=style&index=0&id=a2ed5e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ed5e7c",
  null
  
)

export default component.exports